import {share, map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {ApiService} from './api';
import {Observable, of} from 'rxjs';

@Injectable({providedIn: 'root'})
export class CountriesService {
  path: string = '/api';
  countries: any = null;
  partnerId: number | null = null;
  constructor(private apiService: ApiService) {}

  private observable: Observable<any> | null = null;

  getCountries(partnerId: number) {
    if (partnerId === this.partnerId && this.countries) {
      return of(this.countries);
    } else if (this.observable) {
      return this.observable;
    } else {
      this.observable = this.apiService.get(`${this.path}/partners/${partnerId}/countries`).pipe(
        map((response: any) => {
          this.observable = null;
          this.partnerId = partnerId;
          this.countries = response;
          return this.countries;
        }),
        share(),
      );
      return this.observable;
    }
  }
}
